<template>
  <div id="app">
    <v-app>
      <!-- Global message snackbar-->
      <Message ref="message"></Message>
      <!-- Global dialogs -->
      <ConfirmLogout ref="confirmLogout"></ConfirmLogout>
      <ConfirmDelete ref="confirmDelete"></ConfirmDelete>
      <ConfirmLeave ref="confirmLeave"></ConfirmLeave>
      <toolbar />
      <router-view/>
    </v-app>
  </div>
</template>

<script>
import * as Log from '@/core/logger'
import * as Security from '@/core/security'
import { detectDefaultLand } from '@/core/lang'
import Toolbar from '@/core/components/Toolbar'
import Message from '@/core/components/Message'
import ConfirmLogout from '@/core/components/ConfirmLogout'
import ConfirmDelete from '@/core/components/ConfirmDelete'
import ConfirmLeave from '@/core/components/ConfirmLeave'
import { app } from '@/main'

export default {
  components: {
    Toolbar,
    Message,
    ConfirmLogout,
    ConfirmLeave,
    ConfirmDelete // todo: use this? (currently we never delete, we just set active to false)
  },
  data () {
    return {
      autoLogOutTimer: null
    }
  },
  mounted () {
    // We use next tick to ensure that app is fully initialized
    this.$nextTick(() => {
      detectDefaultLand()

      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })

      // When app starts we try to auto log in
      Security.autoLogin()
    })

    // Example of accessing env, modules ect.
    Log.log('Web App:', process.env.VUE_APP_NAME)
    Log.log('Version:', process.env.VUE_APP_VERSION)
    Log.log('Environment:', process.env.NODE_ENV)
    Log.log('Language:', this.$i18n.locale)
    Log.log('Platform:', navigator.platform)
    Log.log('Inactive auto logout time:', Math.round(Security.maxInactiveSec / 60) + ' mins')

    // Setup easy access to showing messages
    this.$root.$message = this.$refs.message
    // Example of how to show a message
    // this.$root.$message.showSuccess('All is good!')
    // or app.$root.$message.showError('All is good!') if you import { app } from '@/main'

    // Setup easy access to dialogs
    this.$root.$confirmLogout = this.$refs.confirmLogout.open
    this.$root.$confirmDelete = this.$refs.confirmDelete.open
    this.$root.$confirmLeave = this.$refs.confirmLeave.open
    // Example of opening a dialog
    // this.$root.$confirmLogout

    // Let's listen to document events to dertermine if user is still active
    document.addEventListener('mousemove', this.userActivity, false)
    document.addEventListener('touchmove', this.userActivity, false)

    // Customer events
    // To send an event to anywhere in you app do this:
    // app.$emit('my-event', params)

    // To receive an event from anywhere in you app do this:
    // app.$on('my-event', params => {
    //  console.log('params =', params)
    // })
  },
  methods: {
    userActivity () {
      // Tell security module that user is still active
      Security.updateLastActiveTime()
    }
  }
}
</script>

<!--Default we use this relative large font because we want to
aim at a large and simple UI with that are touch friendly.-->
<!-- todo: explain other css -->
<style>
.textsize-svs {
  font-size: 16px;
}
.textsize-small {
  font-size: 11px;
}
.textsize-vt25 {
  font-size: 12px;
}
.textsize-large {
  font-size: 24px;
  font-weight: bold;
}
.thin-border {
  border: 1px solid;
}
@media screen and (max-width: 600px) {
.numPadBtn
{
  font-size: 22px !important;
  height:50px !important;
  min-width:1px !important;
  touch-action: manipulation;
}
}
@media screen and (min-width: 600px) {
.numPadBtn
{
  font-size: 24px !important;
  height:62px !important;
  min-width:1px !important;
  touch-action: manipulation;
}
}

@media screen and (max-width: 600px) {
.txtPadBtn
{
  font-size: 14px !important;
  height:50px !important;
  min-width:1px !important;
  touch-action: manipulation;
}
}
@media screen and (min-width: 600px) {
.txtPadBtn
{
  font-size: 18px !important;
  height:62px !important;
  min-width:1px !important;
  touch-action: manipulation;
}
}

.v-input {
  font-size: 16x;
}
table.v-table tbody td {
  font-size: 14px;
}
.v-data-table thead th.column.sortable {
  font-size: 14px;
}

.medium-zoom-image {
  z-index: 3;
}
.medium-zoom-overlay {
  z-index: 3;
}
.v-list__tile--highlighted {
  background: rgba(0,0,0,.15) !important;
}
/*
 * Use this class on any SVG that should be used in the toolbar nav menu.
*/
.svg-menu-icon {
  fill: rgba(0,0,0,.54);  /* This will make the SVG color/fill gray when not active.*/
  width: 22px;
  height: 22px; /* 22px is the same width and height as the other (icon based) menu items.*/
}
/*
 * When menu item is active, the color of the SVG will turn the same color
 * as the text (SVS blue), so it behaves the same way as the other (icon based) menu items.
*/
.v-list__tile--active .v-list__tile__action:first-of-type .svg-menu-icon {
    fill: inherit;
}

</style>
